import styled from "@emotion/styled";
import PropTypes from "prop-types";

import { capitalizeFirstLetter } from "@hmn/coolinarika-web-core/helpers";

import { ConditionalWrapper } from "../../ConditionalWrapper";
import { ArrowSmallIcon, Icon } from "../../Icon";
import { Image, imageRoundedVariants } from "../../Image";
import { Link } from "../../Link";
import styles from "./ListingElement.style";

const ListingElementStyled = styled.div((props) => ({ ...styles(props) }));

const ListingElement = ({
    imageId,
    title,
    href,
    hrefAs,
    className,
    imageWidth,
    imageHeight,
    onElementClick,
    showIcon,
    ...rest
}) => (
    <ListingElementStyled onClick={onElementClick} className={className} {...rest}>
        <ConditionalWrapper
            condition={!!href}
            Wrapper={Link}
            href={href}
            as={hrefAs}
            className="link"
        >
            <div className="content">
                <div className="image">
                    <Image
                        image={imageId}
                        placeholderBgColor={rest?.placeholderBgColor}
                        title={title}
                        ratio="1x1"
                        width={imageWidth}
                        height={imageHeight}
                        rounded={imageRoundedVariants.SMALL}
                    />
                </div>
                <span className="title">{capitalizeFirstLetter(title)}</span>
                {showIcon && (
                    <div className="iconWrapper">
                        <Icon icon={ArrowSmallIcon} size={28} />
                    </div>
                )}
            </div>
        </ConditionalWrapper>
    </ListingElementStyled>
);

ListingElement.propTypes = {
    className: PropTypes.string,
    imageId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    title: PropTypes.string,
    href: PropTypes.string,
    hrefAs: PropTypes.string,
    imageWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    imageHeight: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onElementClick: PropTypes.func,
    showIcon: PropTypes.bool,
};

ListingElement.defaultProps = {
    className: undefined,
    imageId: undefined,
    title: undefined,
    href: "",
    hrefAs: "",
    imageWidth: 400,
    imageHeight: 400,
    onElementClick: () => {},
    showIcon: true,
};

export default ListingElement;
